/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectAuthStatus, selectAuthUserData } from './auth.slice';
import { ThunkStatus } from '../../enums/ThunkStatus';
import { postSignInThunk } from './auth.thunk';

/* Auth hook */
export function useAuth() {
  const dispatch = useDispatch();

  const status = useSelector(selectAuthStatus);
  const userData = useSelector(selectAuthUserData);

  useEffect(() => {
    if (status === ThunkStatus.IDLE) {
      dispatch(postSignInThunk());
    }
  }, [status, dispatch]);

  return {
    status,
    userData,
  };
}
